/* eslint-disable no-empty */
import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Details
 */
@Component
export class ProductDetails extends ThemeComponent {
    init() {

    }

    public stickySection() {

    }
}
